export default __webpack_public_path__ + "locales/ko-KR/PortalUnavailable.json?hash=4e91202dcfabedd6c2d42443a7cd7a24";